import { useRachelPresentation } from '../../hooks/useRachelPresentation';

export const useRachelDropOverlay = () => {
  const presentation = useRachelPresentation();

  return {
    hasOwnBorder: presentation.mode === 'docked',
    hasInlineBleed: presentation.mode === 'page',
  };
};
